// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Xero Integration Dashboard Styles */

.xero-integration-dashboard {
  padding: 20px;
  background: #f8fafc;
  min-height: 100vh;
}

/* Header */
.xero-integration-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 20px;
  background:
    radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(20, 184, 166, 0.1) 0%, transparent 50%),
    linear-gradient(135deg, #EA580C, #FDBA74);
  border-radius: 12px;
  color: white;
  box-shadow: 0 4px 20px rgba(79, 70, 229, 0.3);
}

.header-content h2 {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 600;
}

.header-content p {
  margin: 0;
  opacity: 0.9;
  font-size: 16px;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.header-actions .btn {
  /* background: rgba(255, 255, 255, 0.2); */
  border: 1px solid rgba(255, 255, 255, 0.3);
  /* color: white; */
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.header-actions .btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.header-actions .btn:disabled {
  opacity: 0.2;
  cursor: not-allowed;
  transform: none;
}

/* Tabs */
.dashboard-tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 30px;
  background: white;
  padding: 4px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.tab-button {
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: #64748b;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.tab-button:hover {
  background: #f1f5f9;
  color: #475569;
}

.tab-button.active {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* Tab Content */
.tab-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Overview Tab */
.overview-tab {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

/* Stats Section */
.stats-section h3,
.recent-activity-section h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.stat-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  font-size: 32px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.stat-card.synced .stat-icon {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
}

.stat-card.pending .stat-icon {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
}

.stat-card.failed .stat-icon {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
}

.stat-card.not-synced .stat-icon {
  background: linear-gradient(135deg, #f3f4f6 0%, #d1d5db 100%);
}

.stat-card.accounts .stat-icon {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
}

.stat-content h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

/* Recent Activity */
.recent-activity-section {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border-left: 4px solid #0D3B66;
}

.activity-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.activity-type {
  font-weight: 500;
  color: #1e293b;
}

.activity-status {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.activity-status.synced {
  background: #dcfce7;
  color: #166534;
}

.activity-status.pending {
  background: #fef3c7;
  color: #92400e;
}

.activity-status.failed {
  background: #fee2e2;
  color: #991b1b;
}

.activity-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  font-size: 14px;
  color: #64748b;
}

.activity-time {
  font-weight: 500;
}

.activity-invoices {
  font-size: 12px;
}

.no-activity {
  text-align: center;
  padding: 40px;
  color: #64748b;
}

/* Loading and Error States */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.error-state {
  text-align: center;
  padding: 40px;
}

.error-state h3 {
  color: #dc2626;
  margin-bottom: 12px;
}

.error-state p {
  color: #64748b;
  margin-bottom: 20px;
}

.access-denied {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.access-denied h3 {
  color: #dc2626;
  margin-bottom: 12px;
}

.access-denied p {
  color: #64748b;
}

/* Responsive Design */
@media (max-width: 768px) {
  .xero-integration-dashboard {
    padding: 16px;
  }

  .xero-integration-dashboard-header {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
  }

  .header-actions {
    justify-content: center;
  }

  .dashboard-tabs {
    flex-direction: column;
  }

  .tab-button {
    justify-content: flex-start;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .activity-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .activity-details {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/xero/XeroIntegrationDashboard.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb;;;6CAG2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Xero Integration Dashboard Styles */\n\n.xero-integration-dashboard {\n  padding: 20px;\n  background: #f8fafc;\n  min-height: 100vh;\n}\n\n/* Header */\n.xero-integration-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 30px;\n  padding: 20px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(20, 184, 166, 0.1) 0%, transparent 50%),\n    linear-gradient(135deg, #EA580C, #FDBA74);\n  border-radius: 12px;\n  color: white;\n  box-shadow: 0 4px 20px rgba(79, 70, 229, 0.3);\n}\n\n.header-content h2 {\n  margin: 0 0 8px 0;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.header-content p {\n  margin: 0;\n  opacity: 0.9;\n  font-size: 16px;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.header-actions .btn {\n  /* background: rgba(255, 255, 255, 0.2); */\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  /* color: white; */\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.header-actions .btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.header-actions .btn:disabled {\n  opacity: 0.2;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Tabs */\n.dashboard-tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 30px;\n  background: white;\n  padding: 4px;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.tab-button {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.tab-button:hover {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.tab-button.active {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n}\n\n/* Tab Content */\n.tab-content {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Overview Tab */\n.overview-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n/* Stats Section */\n.stats-section h3,\n.recent-activity-section h3 {\n  margin: 0 0 20px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.stat-card {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.stat-icon {\n  font-size: 32px;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n}\n\n.stat-card.synced .stat-icon {\n  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);\n}\n\n.stat-card.pending .stat-icon {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n}\n\n.stat-card.failed .stat-icon {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n}\n\n.stat-card.not-synced .stat-icon {\n  background: linear-gradient(135deg, #f3f4f6 0%, #d1d5db 100%);\n}\n\n.stat-card.accounts .stat-icon {\n  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);\n}\n\n.stat-content h4 {\n  margin: 0 0 4px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n/* Recent Activity */\n.recent-activity-section {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.activity-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border-left: 4px solid #0D3B66;\n}\n\n.activity-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.activity-type {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.activity-status {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.activity-status.synced {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.activity-status.pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.activity-status.failed {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.activity-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  font-size: 14px;\n  color: #64748b;\n}\n\n.activity-time {\n  font-weight: 500;\n}\n\n.activity-invoices {\n  font-size: 12px;\n}\n\n.no-activity {\n  text-align: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n/* Loading and Error States */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.error-state {\n  text-align: center;\n  padding: 40px;\n}\n\n.error-state h3 {\n  color: #dc2626;\n  margin-bottom: 12px;\n}\n\n.error-state p {\n  color: #64748b;\n  margin-bottom: 20px;\n}\n\n.access-denied {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.access-denied h3 {\n  color: #dc2626;\n  margin-bottom: 12px;\n}\n\n.access-denied p {\n  color: #64748b;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .xero-integration-dashboard {\n    padding: 16px;\n  }\n\n  .xero-integration-dashboard-header {\n    flex-direction: column;\n    gap: 20px;\n    align-items: stretch;\n  }\n\n  .header-actions {\n    justify-content: center;\n  }\n\n  .dashboard-tabs {\n    flex-direction: column;\n  }\n\n  .tab-button {\n    justify-content: flex-start;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .activity-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .activity-details {\n    align-items: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
